var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17386 10.9998C4.82021 10.9935 4.48172 10.8303 4.24867 10.5523L0.324604 5.87094C0.106005 5.61017 -0.000615871 5.27763 0.0243114 4.93456C0.049394 4.59157 0.202918 4.27904 0.45685 4.05447C0.68438 3.85343 0.974732 3.74267 1.2744 3.74267C1.64047 3.74267 1.9872 3.90583 2.2256 4.19036L5.23155 7.77625L11.8446 0.414762C12.0813 0.15112 12.4174 0 12.7668 0C13.0827 0 13.3846 0.121215 13.617 0.341395C13.8632 0.574574 14.0062 0.892444 14.0197 1.23607C14.0332 1.57986 13.9155 1.90841 13.6884 2.16129L6.12094 10.5852C5.88417 10.8488 5.54823 11 5.19909 11L5.17386 10.9998Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7a46124470ebec6b7e8e42ce0ec4a5d5.svg";
export { ForwardRef as ReactComponent };